export const MFA_RESEND_COOLDOWN_SECONDS = 30;
export const MFA_RESEND_COOLDOWN_STORAGE_KEY = 'mfa_resend_cooldown_end';
